import React, { useContext } from 'react'
import { FormikProvider, useFormik } from 'formik'
import * as Yup from 'yup'
import { TextField, MaskedTextField } from '../../components/FormikInput'
import { UsuarioModel } from '../../models/UsuarioModel'
import { ImgCropper } from '../../components/ImgCropper'
import { Fieldset, Padding, DisplayFlex } from '../../components/Styles'
import api from '../../api'
import { PerfilStoreValues, PerfilStoreCtx } from './Perfil'
import { GlobalStoreValues, GlobalStoreCtx } from '../../GlobalStore'
import { ButtonLoader } from '../../components/ButtonLoader'
import { Redirect } from 'react-router'
import { Button } from '../../components/semantic-ui-antd-adapter'

let imgCropper: any

export const PerfilView = () => {
  const { isLoading } = useContext<GlobalStoreValues>(GlobalStoreCtx)
  const { usuario, updatePerfil, cancelar, setLoading, redirectTo } =
    useContext<PerfilStoreValues>(PerfilStoreCtx)

  const uploadFile = async () => {
    setLoading()
    const formData = new FormData()
    formData.append('file', getFileFromDataURL(imgCropper.getCroppedImage()))
    const path = await api.Files.upload(formData)
    return path
  }

  const getFileFromDataURL = (dataURL: string): Blob => {
    const blobBin = atob(dataURL.split(',')[1])
    const array = []
    for (let i = 0; i < blobBin.length; i++) {
      array.push(blobBin.charCodeAt(i))
    }

    return new Blob([new Uint8Array(array)], { type: 'image/jpg' })
  }

  const formik = useFormik({
    initialValues: {
      nome: usuario?.nome || '',
      telefone: usuario?.telefone || '',
      cpf: usuario?.cpf || '',
      email: usuario?.email || '',
    },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      nome: Yup.string().required(),
      cpf: Yup.string().required(),
      email: Yup.string().email().required(),
    }),
    onSubmit: async (values: Partial<UsuarioModel>) => {
      const newValues = { ...values }
      if (imgCropper.hasNewImage()) {
        newValues.avatar = (await uploadFile()).filepath
      }
      updatePerfil(newValues as UsuarioModel)
    },
  })

  if (redirectTo) return <Redirect to={redirectTo} push />

  return (
    <div>
      <Fieldset>
        <legend>Editar Perfil</legend>
        <FormikProvider value={formik}>
          <form onSubmit={formik.handleSubmit}>
            <TextField label="Nome" name="nome" placeholder="Nome" className="input-uppercase" />
            <br />

            <MaskedTextField label="CPF" mask="cpf" name="cpf" placeholder="CPF" disabled={true} />
            <br />

            <MaskedTextField label="Celular" mask="celular" name="telefone" placeholder="Celular" />
            <br />

            <TextField label="E-mail" name="email" placeholder="E-mail" type="email" />
            <br />

            <Padding vertical={true}>
              <ImgCropper
                ref={(e) => {
                  imgCropper = e
                }}
                src={usuario.avatar}
                onRemoveFoto={() => formik.setFieldValue('avatar', '')}
              />
            </Padding>

            <DisplayFlex marginBetween={8}>
              <ButtonLoader
                variant="contained"
                type="submit"
                disabled={isLoading}
                loading={isLoading}
              >
                Enviar
              </ButtonLoader>
              <Button variant="contained" type="button" onClick={cancelar}>
                Cancelar
              </Button>
            </DisplayFlex>
          </form>
        </FormikProvider>
      </Fieldset>
    </div>
  )
}
